import {
  meetingHistoryRepo,
  type AttendanceTimeline,
  type PastMeetingDetail,
} from './meeting-history.repo'

export const meetingHistoryService = {
  async getPastMeeting(id: string): Promise<PastMeetingDetail> {
    if (!id) throw new Error('Meeting id is required')
    return meetingHistoryRepo.getPastMeeting(id)
  },
  async getAttendanceTimeline(id: string): Promise<AttendanceTimeline> {
    if (!id) throw new Error('Meeting id is required')
    return meetingHistoryRepo.getAttendanceTimeline()
  },
}

export type {
  PastMeetingDetail,
  PastMeetingParticipant,
  PastMeetingRecording,
  PastMeetingChatMessage,
  PastMeetingTranscriptEntry,
  AttendanceStatus,
  AttendanceTimeline,
  AttendanceTimelineRecord,
} from './meeting-history.repo'
